export default "__VITE_ASSET__c0478fbc__"